import React, { useState, useRef, useEffect, useContext } from "react";
import { Col, Container, Row, Tabs } from "react-bootstrap";
import "./TrendingMF.css";
import cart from "../../../images/cart.png";
import URLstateContext from "../../../provider/CommonContext";
import Button from "@mui/material/Button";
import {
  GetPostMethodData,
  DecryptAESdata,
} from "../../../provider/ServiceProvider";
import { BsArrowLeft, BsArrowRight } from "react-icons/bs";
import Slider from "react-slick";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { format, parseISO } from "date-fns";
import animation from "../../../images/jm-animation.gif";
import { schemaHasRules } from "ajv/dist/compile/util";



const TABS = [
  { key: "EquitySchemes", label: "Equity", dataId: "ES" },
  { key: "DebtSchemes", label: "Fixed Income", dataId: "DS" },
  { key: "HybridSchemes", label: "Hybrid", dataId: "HS" },
];


function TrendingMFNew() {
  const [data, setData] = useState([]);
  const { BaseURL } = useContext(URLstateContext);
  const [type, setType] = useState("Equity");
  const [periodValue, setPeriodValue] = useState("3y");
  const [periodValue1, setPeriodValue1] = useState("3y");
  const [periodValue2, setPeriodValue2] = useState("3y");
  const [value, setValue] = React.useState("Equity");
  const [loadingshow, setloadingshow] = useState(false);
  const [isToggleOn, setToggleOn] = useState("Regular");

  const [activeTab, setActiveTab] = useState("EquitySchemes");

  let valueDrp2;
  // alert(isToggleOn)
  const handleClick = () => {
    setToggleOn((prevState) =>
      prevState === "Regular" ? "Direct" : "Regular",
    );
  };

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  useEffect(() => {
    setloadingshow(true);
    GetPostMethodData(BaseURL + "GetNAVDetails", {
      type: type,
      IVSchemeType: isToggleOn,
      IVOuput: "Home",
      IVFundSearch: "",
    }).then((data) => {
      if (data.data != null && data.data.length > 0) {
        const homePageData = setData(DecryptAESdata(data.data));
        setloadingshow(false);
        let dataNav = DecryptAESdata(data.data);
        
        let valueDrp = dataNav[0].SAR6Mon;
        let valueDrp1 = dataNav[1].SAR6Mon;
        if (dataNav[2] != undefined) {
          valueDrp2 = dataNav[2].SAR6Mon;
        }
        if (valueDrp && valueDrp !== "") {
          setPeriodValue("6M");
        } else {
          setPeriodValue("3y"); // 👈 instead of 1y
        }
        if (valueDrp1 != null) {
          setPeriodValue1("6M");
        } else {
          setPeriodValue1("3y"); // 👈 instead of 1y
        }
        if (valueDrp2 != null) {
          setPeriodValue2("6M");
        } else {
          setPeriodValue2("3y"); // 👈 instead of 1y
        }
      } else {
        setData(null);
        setloadingshow(false);
      }
    });
  }, [BaseURL, type, isToggleOn]);

  const ChangeSchemeTab = (key) => {
    setloadingshow(true);
    setType(key);
    GetPostMethodData(BaseURL + "GetNAVDetails", {
      type: key,
      IVSchemeType: isToggleOn,
      IVOuput: "Home",
      IVFundSearch: "",
    }).then(
      (data) => {
        if (data.data != null && data.data.length > 0) {
          setData(DecryptAESdata(data.data));
          setloadingshow(false);
          let dataNav = DecryptAESdata(data.data);
          let valueDrp = dataNav[0].SAR6Mon;
          let valueDrp1 = dataNav[1].SAR6Mon;
          if (dataNav[2] != undefined) {
            valueDrp2 = dataNav[2].SAR6Mon;
          }
          if (valueDrp != null) {
            setPeriodValue("6M");
          } else {
            setPeriodValue("1y");
          }
          if (valueDrp1 != null) {
            setPeriodValue1("6M");
          } else {
            setPeriodValue1("1y");
          }
          if (valueDrp2 != null) {
            setPeriodValue2("6M");
          } else {
            setPeriodValue2("1y");
          }
        } else {
          setData(null);
          setloadingshow(false);
        }
      },
      [isToggleOn],
    );
  };

  // const fetchData = (newType, newIsToggleOn) => {
  //   setloadingshow(true);
  //   GetPostMethodData(BaseURL + "GetNAVDetails", {
  //     type: newType,
  //     IVSchemeType: newIsToggleOn,
  //     IVOuput: 'Home',
  //     IVFundSearch: ''
  //   }).then((data) => {
  //     if (data.data != null && data.data.length > 0) {
  //       setData(DecryptAESdata(data.data));
  //       setloadingshow(false);
  //     } else {
  //       setData(null);
  //       setloadingshow(false);
  //     }
  //   });
  // };

  // useEffect(() => {
  //   fetchData(type, isToggleOn);
  // }, [BaseURL, type, isToggleOn]);

  // const ChangeSchemeTab = (key) => {
  //   setType(key);
  //   if (key !== type) {
  //     fetchData(key, isToggleOn);
  //   }
  // };



  const handleFormChangeDebt = (index, DrpPeriod, SchemeCode) => {
    var period = DrpPeriod.target.value;
    var PeriodValue = period.split("~");
    for (var i = 1; i <= 3; i++) {
      if (PeriodValue[i] === "null") {
        PeriodValue[i] = "-";
      }
    }

    // Update the displayed values
    document.getElementById(`DebtAnnualizedDiv-${SchemeCode}`).innerText =
      PeriodValue[1] === "-" ? PeriodValue[1] : PeriodValue[1] + "%";
    document.getElementById(`DebtBenchmarkReturnsDiv-${SchemeCode}`).innerText =
      PeriodValue[2] === "-" ? PeriodValue[2] : PeriodValue[2] + "%";

    // Update investment returns only if it's not "null"
    if (PeriodValue[3] !== "null") {
      document.getElementById(`DebtInvestmentReturnsDiv-${SchemeCode}`).innerText =
        PeriodValue[3];
    }
  };
  const clickGetSchemes = (event) => {
    const schemeId = event.currentTarget.dataset.id;
    const schemeType = event.currentTarget.dataset.type;
    const schemeName = event.currentTarget.dataset.name;
    const schemeDesc = event.currentTarget.dataset.disc;
    window.open(
      "/products/" +
        schemeType.replace(/ /g, "-").replace("&", "and").replace("+", "") +
        "/" +
        schemeName.replace(/ /g, "-").replace("&", "and").replace("+", "") +
        "/" +
        schemeId +
        "/" +
        schemeDesc.replace(/ /g, "-").replace("&", "and"),
      "_self",
    );
  };
  const handleFormChangeHybrid = (index, DrpPeriod, SchemeCode) => {
    var period = DrpPeriod.target.value;
    var PeriodValue = period.split("~");
    if (PeriodValue[1] === "null") PeriodValue[1] = "-";
    if (PeriodValue[2] === "null") PeriodValue[2] = "-";
    if (PeriodValue[3] === "null") PeriodValue[3] = "-";
    document.getElementById(`HybridAnnualizedDiv-${SchemeCode}`).innerText =
      PeriodValue[1] + "%";
    document.getElementById(`HybridBenchmarkReturnsDiv-${SchemeCode}`).innerText =
      PeriodValue[2] + "%";
    document.getElementById(`HybridInvestmentReturnsDiv-${SchemeCode}`).innerText =
      PeriodValue[3];
    // for (var i = 1; i <= 3; i++) {
    //   if (PeriodValue[i] === "null") {
    //     PeriodValue[i] = "-";
    //   }
    // }

    // document.getElementById("HybridAnnualizedDiv" + index).innerText =
    //   PeriodValue[1] === "-" ? PeriodValue[1] : PeriodValue[1] + "%";
    // document.getElementById("HybridBenchmarkReturnsDiv" + index).innerText =
    //   PeriodValue[2] === "-" ? PeriodValue[2] : PeriodValue[2] + "%";

    // if (PeriodValue[3] !== "null") {
    //   document.getElementById("HybridInvestmentReturnsDiv" + index).innerText =
    //     PeriodValue[3];
    // }
  };
  const BlogSlider = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <BsArrowRight />,
    prevArrow: <BsArrowLeft />,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          // nextArrow: <BsArrowRight />,
          // prevArrow: <BsArrowLeft />,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          // nextArrow: <BsArrowRight />,
          // prevArrow: <BsArrowLeft />,
        },
      },
    ],
  };

  const handleTabClick = (tabKey) => {
    setActiveTab(tabKey);
    if (typeof ChangeSchemeTab === "function") {
      ChangeSchemeTab(tabKey);
    }
  };

  
  return (
    <>
      <section className="trending-mf-sc">
        <Container>
          <Row>
            <Col sm={12}>
              <div className="trending-pnl button-css">
                <div
                  className="trending-section"
                  id="home-main-heading"
                  tabIndex="-1"
                >
                  <h2>
                     Trending mutual fund schemes
                  </h2>
                </div>

                {/* <div class="toggle-switch-container-trending">
                  <span>Direct</span>
                  <div class="toggle-switch">
                    <button
                      value="Regular"
                      class="knob"
                    ></button>
                  </div>
                  <span>Regular</span>
                </div> */}
                {/* <div className="toggle-swich-container-treading">
                  <span>Direct Plan</span>
                  <div
                    onClick={handleClick}
                    className={`toggle-switch ${
                      isToggleOn === "Regular" ? "active" : ""
                    }`}
                  >
                    <a
                      value={isToggleOn}
                      onClick={(event) => {
                        event.stopPropagation();
                      }}
                      className={`knob ${
                        isToggleOn === "Regular" ? "active" : ""
                      }`}
                    ></a>
                  </div>
                  <span>Regular Plan</span>
                </div> */}
                <div className="trending-mf-header">
      {/* ===================== Custom Tab Buttons (LEFT) ===================== */}
      <div className="trending-mf-tabs" role="tablist" aria-label="Scheme categories">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            type="button"
            role="tab"
            data-id={tab.dataId}
            aria-selected={activeTab === tab.key}
            className={`trending-mf-tab-btn ${activeTab === tab.key ? "active" : ""}`}
            onClick={() => handleTabClick(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* ===================== Direct / Regular Toggle (RIGHT) ===================== */}
      <div className="toggle-swich-container-treading">
        <span>Direct Plan</span>

        <button
          type="button"
          onClick={handleClick}
          className={`toggle-switch ${isToggleOn === "Regular" ? "active" : ""}`}
          aria-pressed={isToggleOn === "Regular"}
          aria-label={`Toggle plan. Currently ${
            isToggleOn === "Regular" ? "Regular Plan" : "Direct Plan"
          }`}
        >
          <span className={`knob ${isToggleOn === "Regular" ? "active" : ""}`}></span>
        </button>

        <span>Regular Plan</span>
      </div>

      {/* ===================== Equity Panel ===================== */}
      {activeTab === "EquitySchemes" && (
        <div className="trending-mf-panel" role="tabpanel">
          {data === null ? <p className="errormsgComNew">No Data Available</p> : ""}
          {data &&
            data.map(
              (
                {
                  PlanDesc,
                  FundName,
                  risk,
                  SchemeCode,
                  categoryname,
                  NAV,
                  NAVdate,
                  CAGRInception,
                  BCAGRInception,
                  VOIInception,
                  SAR6Mon,
                  VOI6Mon,
                  BSAR6Mon,
                  BCAGR1Yr,
                  CAGR1Yr,
                  BCAGR3Yr,
                  CAGR3Yr,
                  BCAGR5Yr,
                  CAGR5Yr,
                  riskimage,
                  VOI1Yr,
                  VOI3Yr,
                  VOI5Yr,
                  SchemeAsonDate,
                },
                index,
              ) => (
                <div className="trending-data" key={SchemeCode || index}>
                  <ul>
                    <li className="text-left">
                      <h2 className="heading-small">{PlanDesc} </h2>
                      <p>{FundName}</p>
                    </li>

                    <li className="text-right">
                      <span className="text-wrap-span">
                        NAV as on{" "}
                        {NAVdate != null ? format(parseISO(NAVdate), "do MMM, yyyy") : ""}
                      </span>

                      <div className="font-family-normal">
                        {NAV != null ? Number(NAV).toFixed(2) : "-"}
                      </div>
                    </li>
                    <li className="riskom">
                      <span className="heading-small">Riskometer :</span>
                      <span>{risk}</span>
                      <p className="riskometer-para">
                        <img alt={risk} src={riskimage} className="img-fluid" />
                      </p>
                    </li>

                    <li className="text-center">
                      <label htmlFor={`equity-period-${SchemeCode}`} id={`equity-period-${SchemeCode}-label`}>
                        Period
                      </label>
                      <select
                        name="amount"
                        id={`equity-period-${SchemeCode}`}
                        autoComplete="off"
                        value={index === 0 ? periodValue : index === 1 ? periodValue1 : periodValue2}
                        onChange={(event) => {
                          if (index === 0) setPeriodValue(event.target.value);
                          if (index === 1) setPeriodValue1(event.target.value);
                          if (index === 2) setPeriodValue2(event.target.value);
                        }}
                        aria-label={`Period for ${categoryname}  scheme for ${SchemeCode}`}
                      >
                        {SAR6Mon != null ? <option value={"6M"}>6 Months</option> : ""}
                        <option value={"1y"}>1Y</option>
                        <option value={"3y"}>3Y</option>
                        <option value={"5y"}>5Y</option>
                        <option value={"Inc."}>Since Inception</option>
                      </select>
                    </li>

                    {(() => {
                      const pv = index === 0 ? periodValue : index === 1 ? periodValue1 : index === 2 ? periodValue2 : null;
                      if (pv === null) return "";
                      const map = {
                        "6M": [SAR6Mon, BSAR6Mon],
                        "1y": [CAGR1Yr, BCAGR1Yr],
                        "3y": [CAGR3Yr, BCAGR3Yr],
                        "5y": [CAGR5Yr, BCAGR5Yr],
                        "Inc.": [CAGRInception, BCAGRInception],
                      };
                      const pair = map[pv];
                      if (!pair) return "";
                      const [scheme, bench] = pair;
                      return (
                        <>
                          <li className="text-right skimm">
                            <span className="heading-small">Scheme Returns (CAGR)</span>
                            <div id={`EquityAnnualizedDiv-${SchemeCode}`}>
                              {scheme != null ? scheme + "%" : "-"}
                            </div>
                          </li>
                          <li className="text-right">
                            <span className="heading-small">Benchmark Return (CAGR)</span>
                            <div id={`EquityBenchmarkReturnsDiv-${SchemeCode}`}>
                              {bench != null ? bench + "%" : "-"}
                            </div>
                          </li>
                        </>
                      );
                    })()}
                  </ul>
                  <hr />
                  <ul className="trending-data-2" style={{ justifyContent: "center" }}>
                    <li className="TrendingMfList">
                      <div className="know-more-ason">
                        <li role="presentation">
                          <strong>₹10,000</strong> investment grew to{" "}
                          <strong>
                            ₹
                            <span className="ClassAmt" id={`EquityInvestmentReturnsDiv-${SchemeCode}`}>
                              {(() => {
                                const pv = index === 0 ? periodValue : index === 1 ? periodValue1 : index === 2 ? periodValue2 : null;
                                const voiMap = {
                                  "6M": VOI6Mon,
                                  "1y": VOI1Yr,
                                  "3y": VOI3Yr,
                                  "5y": VOI5Yr,
                                  "Inc.": VOIInception,
                                };
                                const val = pv != null ? voiMap[pv] : null;
                                return val != null ? val.toLocaleString("en-in") : "-";
                              })()}
                            </span>
                          </strong>
                        </li>

                        <div className="ason">
                          <span className="margin0 heading-small">
                            As on -{" "}
                            {SchemeAsonDate ? format(parseISO(SchemeAsonDate), "do MMM, yyyy") : "-"}
                          </span>
                        </div>

                        <div className="know-more-new">
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              clickGetSchemes(e);
                            }}
                            data-id={SchemeCode}
                            data-type={categoryname}
                            data-name={FundName}
                            data-disc={PlanDesc}
                            aria-label={`Know more about ${FundName}`}
                          >
                            Know More
                          </a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              ),
            )}
        </div>
      )}

      {/* ===================== Fixed Income Panel ===================== */}
      {activeTab === "DebtSchemes" && (
        <div className="trending-mf-panel" role="tabpanel">
          {data === null ? <h5 className="errormsgComNew">No Data Available</h5> : ""}
          {data &&
            data.map(
              (
                {
                  PlanDesc,
                  FundName,
                  risk,
                  NAV,
                  NAVdate,
                  CAGRInception,
                  SchemeCode,
                  categoryname,
                  VOIInception,
                  BCAGRInception,
                  SAR6Mon,
                  VOI6Mon,
                  BSAR6Mon,
                  BCAGR1Yr,
                  CAGR1Yr,
                  BCAGR3Yr,
                  CAGR3Yr,
                  BCAGR5Yr,
                  CAGR5Yr,
                  riskimage,
                  VOI1Yr,
                  VOI3Yr,
                  VOI5Yr,
                  SchemeAsonDate,
                },
                index,
              ) => (
                <div className="trending-data" key={SchemeCode || index}>
                  <ul>
                    <li className="text-left">
                      <h2 className="heading-small">{PlanDesc}</h2>
                      <p>{FundName}</p>
                    </li>
                    <li className="text-right">
                      <span className="text-wrap-span">
                        NAV as on{" "}
                        {NAVdate != null ? format(parseISO(NAVdate), "do MMM, yyyy") : ""}
                      </span>
                      <div className="font-family-normal">
                        {NAV != null ? Number(NAV).toFixed(2) : "-"}
                      </div>
                    </li>
                    <li className="riskom">
                      <span className="heading-small">Riskometer :</span>
                      <span>{risk}</span>
                      <p className="riskometerr-para">
                        <img alt={risk} src={riskimage} className="img-fluid" />
                      </p>
                    </li>
                    <li className="text-center">
                      <label htmlFor={`debt-period-${FundName}`} id={`debt-period-${FundName}-label`}>
                        Period
                      </label>
                      <select
                        name="amount"
                        id={`debt-period-${FundName}`}
                        autoComplete="off"
                        value={index === 0 ? periodValue : index === 1 ? periodValue1 : periodValue2}
                        onChange={(event) => {
                          if (index === 0) setPeriodValue(event.target.value);
                          if (index === 1) setPeriodValue1(event.target.value);
                          if (index === 2) setPeriodValue2(event.target.value);
                        }}
                        aria-label={`Period for debt scheme ${FundName}`}
                      >
                        {SAR6Mon != null ? <option value={"6M"}>6 Months</option> : ""}
                        <option value={"1y"}>1Y</option>
                        <option value={"3y"}>3Y</option>
                        <option value={"5y"}>5Y</option>
                        <option value={"Inc."}>Since Inception</option>
                      </select>
                    </li>

                    {(() => {
                      const pv = index === 0 ? periodValue : index === 1 ? periodValue1 : index === 2 ? periodValue2 : null;
                      if (pv === null) return "";
                      const map = {
                        "6M": [SAR6Mon, BSAR6Mon],
                        "1y": [CAGR1Yr, BCAGR1Yr],
                        "3y": [CAGR3Yr, BCAGR3Yr],
                        "5y": [CAGR5Yr, BCAGR5Yr],
                        "Inc.": [CAGRInception, BCAGRInception],
                      };
                      const pair = map[pv];
                      if (!pair) return "";
                      const [scheme, bench] = pair;
                      return (
                        <>
                          <li className="text-right skimm">
                            <span className="heading-small">Scheme Returns (CAGR)</span>
                            <div id={`DebtAnnualizedDiv-${SchemeCode}`}>
                              {scheme != null ? scheme + "%" : "-"}
                            </div>
                          </li>
                          <li className="text-right">
                            <span className="heading-small">Benchmark Return (CAGR)</span>
                            <div id={`DebtBenchmarkReturnsDiv-${SchemeCode}`}>
                              {bench != null ? bench + "%" : "-"}
                            </div>
                          </li>
                        </>
                      );
                    })()}
                  </ul>
                  <hr />
                  <ul className="trending-data-2" role="presentation">
                    <div className="know-more-ason">
                      <li role="presentation">
                        <strong>&#8377;10,000</strong> investment grew to{" "}
                        <strong>
                          &#8377;
                          <div className="ClassAmt" id={`DebtInvestmentReturnsDiv-${SchemeCode}`}>
                            {(() => {
                              const pv = index === 0 ? periodValue : index === 1 ? periodValue1 : index === 2 ? periodValue2 : null;
                              const voiMap = {
                                "6M": VOI6Mon,
                                "1y": VOI1Yr,
                                "3y": VOI3Yr,
                                "5y": VOI5Yr,
                                "Inc.": VOIInception,
                              };
                              const val = pv != null ? voiMap[pv] : null;
                              return val != null ? val.toLocaleString("en-in") : "-";
                            })()}
                          </div>
                        </strong>
                      </li>
                      <div className="ason">
                        <span className="margin0 heading-small">
                          As on -{" "}
                          {data[0] != undefined
                            ? data[0].SchemeAsonDate != null
                              ? format(parseISO(data[0].SchemeAsonDate), "do MMM, yyyy")
                              : "-"
                            : ""}
                        </span>
                      </div>
                      <div className="know-more-new">
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            clickGetSchemes(e);
                          }}
                          aria-label={`Know more about ${FundName}`}
                          data-id={SchemeCode}
                          data-type={categoryname}
                          data-name={FundName}
                          data-disc={PlanDesc}
                        >
                          Know More
                        </a>
                      </div>
                    </div>
                  </ul>
                </div>
              ),
            )}
        </div>
      )}

      {/* ===================== Hybrid Panel ===================== */}
      {activeTab === "HybridSchemes" && (
        <div className="trending-mf-panel" role="tabpanel">
          {data === null ? <h5 className="errormsgComNew">No Data Available</h5> : ""}
          {data &&
            data.map(
              (
                {
                  PlanDesc,
                  FundName,
                  risk,
                  NAV,
                  NAVdate,
                  CAGRInception,
                  SchemeCode,
                  categoryname,
                  SAR6Mon,
                  VOI6Mon,
                  BSAR6Mon,
                  VOIInception,
                  BCAGRInception,
                  BCAGR1Yr,
                  CAGR1Yr,
                  BCAGR3Yr,
                  CAGR3Yr,
                  BCAGR5Yr,
                  CAGR5Yr,
                  riskimage,
                  VOI1Yr,
                  VOI3Yr,
                  VOI5Yr,
                },
                index,
              ) => (
                <div className="trending-data" key={SchemeCode || index}>
                  <ul>
                    <li className="text-left">
                      <h2 className="heading-small">{PlanDesc}</h2>
                      <p>{FundName}</p>
                    </li>
                    <li className="text-right">
                      <span className="text-wrap-span">
                        NAV as on{" "}
                        {NAVdate != null ? format(parseISO(NAVdate), "do MMM, yyyy") : ""}
                      </span>
                      <div className="font-family-normal">
                        {NAV != null ? Number(NAV).toFixed(2) : "-"}
                      </div>
                    </li>
                    <li className="riskom">
                      <span className="heading-small">Riskometer :</span>
                      <span>{risk}</span>
                      <p align="center" className="riskometer-para">
                        <img alt={risk} src={riskimage} className="img-fluid" />
                      </p>
                    </li>
                    <li className="text-center">
                      <label htmlFor={`hybrid-period-${FundName}`} id={`hybrid-period-${FundName}-label`}>
                        Period
                      </label>
                      <select
                        id={index}
                        value={index === 0 ? periodValue : index === 1 ? periodValue1 : periodValue2}
                        onChange={(event) => {
                          if (index === 0) setPeriodValue(event.target.value);
                          if (index === 1) setPeriodValue1(event.target.value);
                          if (index === 2) setPeriodValue2(event.target.value);
                        }}
                        aria-label={`Period for hybrid scheme ${FundName}`}
                      >
                        {SAR6Mon != null ? <option value={"6M"}>6 Months</option> : ""}
                        <option value={"1y"}>1Y</option>
                        <option value={"3y"}>3Y</option>
                        <option value={"5y"}>5Y</option>
                        <option value={"Inc."}>Since Inception</option>
                      </select>
                    </li>

                    {(() => {
                      const pv = index === 0 ? periodValue : index === 1 ? periodValue1 : index === 2 ? periodValue2 : null;
                      if (pv === null) return "";
                      const map = {
                        "6M": [SAR6Mon, BSAR6Mon],
                        "1y": [CAGR1Yr, BCAGR1Yr],
                        "3y": [CAGR3Yr, BCAGR3Yr],
                        "5y": [CAGR5Yr, BCAGR5Yr],
                        "Inc.": [CAGRInception, BCAGRInception],
                      };
                      const pair = map[pv];
                      if (!pair) return "";
                      const [scheme, bench] = pair;
                      return (
                        <>
                          <li className="text-right skimm">
                            <span className="heading-small">Scheme Returns (CAGR)</span>
                            <div id={`HybridAnnualizedDiv-${SchemeCode}`}>
                              {scheme != null ? scheme + "%" : "-"}
                            </div>
                          </li>
                          <li className="text-right">
                            <span className="heading-small">Benchmark Return (CAGR)</span>
                            <div id={`HybridBenchmarkReturnsDiv-${SchemeCode}`}>
                              {bench != null ? bench + "%" : "-"}
                            </div>
                          </li>
                        </>
                      );
                    })()}
                  </ul>
                  <hr />
                  <ul className="trending-data-2" role="presentation">
                    <div className="know-more-ason">
                      <li role="presentation">
                        <strong>&#8377;10,000</strong> investment grew to{" "}
                        <strong>
                          &#8377;
                          <div className="ClassAmt" id={`HybridInvestmentReturnsDiv-${SchemeCode}`}>
                            {(() => {
                              const pv = index === 0 ? periodValue : index === 1 ? periodValue1 : index === 2 ? periodValue2 : null;
                              const voiMap = {
                                "6M": VOI6Mon,
                                "1y": VOI1Yr,
                                "3y": VOI3Yr,
                                "5y": VOI5Yr,
                                "Inc.": VOIInception,
                              };
                              const val = pv != null ? voiMap[pv] : null;
                              return val != null ? val.toLocaleString("en-in") : "-";
                            })()}
                          </div>
                        </strong>
                      </li>
                      <div className="ason">
                        <span className="margin0 heading-small">
                          As on -{" "}
                          {data[1] != undefined
                            ? data[1].SchemeAsonDate != null
                              ? format(parseISO(data[1].SchemeAsonDate), "do MMM, yyyy")
                              : "-"
                            : ""}
                        </span>
                      </div>
                     
                      <div className="know-more-new">
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            clickGetSchemes(e);
                          }}
                          data-id={SchemeCode}
                          data-type={categoryname}
                          data-name={FundName}
                          data-disc={PlanDesc}
                          aria-label={`Know more about ${FundName}`}
                        >
                          Know More
                        </a>
                      </div>
                    
                    </div>
                  </ul>
                </div>
              ),
            )}
        </div>
      )}
    </div>
                {/* <div className='toggle-swich-container-treading'>
                  <span>Direct</span>
                  <div onClick={handleClick} className={`toggle-switch ${isToggleOn === 'Regular' ? 'active' : ''}`}>
                    <button
                      value={isToggleOn}
                      onClick={(event) => {
                        event.stopPropagation();
                      }}
                      className={`knob ${isToggleOn === 'Regular' ? 'active' : ''}`}
                    >
                    </button>

                  </div>
                  <span>Regular</span>
                </div> */}
                {/* <div>
                <button onClick={handleChange} value='Equity'>Equity</button>
                <button onClick={handleChange} value='Hybrid'>Hybrid</button>
                <button onClick={handleChange} value='fixedincome'>Fixed Income</button>
               </div> */}
              

                <div className="know-more-fund-button-blog">
                  <a href="/products" className="btn-ourfund" aria-label="View all products">
                    {" "}
                    View All{" "}
                    <i
                      class="fa fa-arrow-circle-o-right"
                    ></i>
                  </a>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default TrendingMFNew;
